import script from "./updateCountdownProposal.vue?vue&type=script&lang=js"
export * from "./updateCountdownProposal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__